function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
import { StaveNote } from './stavenote';
import { Stem } from './stem';
import { Flow } from './tables';
export var GraceNote = /*#__PURE__*/function (_StaveNote) {
  _inherits(GraceNote, _StaveNote);

  var _super = _createSuper(GraceNote);

  _createClass(GraceNote, null, [{
    key: "CATEGORY",
    get: function get() {
      return 'gracenotes';
    }
  }, {
    key: "LEDGER_LINE_OFFSET",
    get: function get() {
      return 2;
    }
  }, {
    key: "SCALE",
    get: function get() {
      return 0.66;
    }
  }]);

  function GraceNote(note_struct) {
    var _this;

    _classCallCheck(this, GraceNote);

    _this = _super.call(this, Object.assign(note_struct, {
      glyph_font_scale: Flow.DEFAULT_NOTATION_FONT_SCALE * GraceNote.SCALE,
      stroke_px: GraceNote.LEDGER_LINE_OFFSET
    }));

    _this.setAttribute('type', 'GraceNote');

    _this.slash = note_struct.slash;
    _this.slur = true;

    _this.buildNoteHeads();

    _this.width = 3;
    return _this;
  }

  _createClass(GraceNote, [{
    key: "getStemExtension",
    value: function getStemExtension() {
      if (this.stem_extension_override != null) {
        return this.stem_extension_override;
      }

      var glyph = this.getGlyph();

      if (glyph) {
        var ret = _get(_getPrototypeOf(GraceNote.prototype), "getStemExtension", this).call(this);

        if (glyph.stem) {
          var staveNoteScale = this.getStaveNoteScale();
          ret = (Stem.HEIGHT + ret) * staveNoteScale - Stem.HEIGHT;
        }

        return ret;
      }

      return 0;
    }
  }, {
    key: "getCategory",
    value: function getCategory() {
      return GraceNote.CATEGORY;
    } // FIXME: move this to more basic class.

  }, {
    key: "getStaveNoteScale",
    value: function getStaveNoteScale() {
      return this.render_options.glyph_font_scale / Flow.DEFAULT_NOTATION_FONT_SCALE;
    }
  }, {
    key: "draw",
    value: function draw() {
      _get(_getPrototypeOf(GraceNote.prototype), "draw", this).call(this);

      this.setRendered();
      var stem = this.stem;

      if (this.slash && stem) {
        var staveNoteScale = this.getStaveNoteScale(); // some magic numbers are based on the staveNoteScale 0.66.

        var offsetScale = staveNoteScale / 0.66;
        var slashBBox = undefined;
        var beam = this.beam;

        if (beam) {
          // FIXME: should render slash after beam?
          if (!beam.postFormatted) {
            beam.postFormat();
          }

          slashBBox = this.calcBeamedNotesSlashBBox(8 * offsetScale, 8 * offsetScale, {
            stem: 6 * offsetScale,
            beam: 5 * offsetScale
          });
        } else {
          var stem_direction = this.getStemDirection();
          var noteHeadBounds = this.getNoteHeadBounds();
          var noteStemHeight = stem.getHeight();
          var x = this.getAbsoluteX();
          var y = stem_direction === Flow.Stem.DOWN ? noteHeadBounds.y_top - noteStemHeight : noteHeadBounds.y_bottom - noteStemHeight;
          var defaultStemExtention = stem_direction === Flow.Stem.DOWN ? this.glyph.stem_down_extension : this.glyph.stem_up_extension;
          var defaultOffsetY = Flow.STEM_HEIGHT;
          defaultOffsetY -= defaultOffsetY / 2.8;
          defaultOffsetY += defaultStemExtention;
          y += defaultOffsetY * staveNoteScale * stem_direction;
          var offsets = stem_direction === Flow.Stem.UP ? {
            x1: 1,
            y1: 0,
            x2: 13,
            y2: -9
          } : {
            x1: -4,
            y1: 1,
            x2: 13,
            y2: 9
          };
          x += offsets.x1 * offsetScale;
          y += offsets.y1 * offsetScale;
          slashBBox = {
            x1: x,
            y1: y,
            x2: x + offsets.x2 * offsetScale,
            y2: y + offsets.y2 * offsetScale
          };
        } // FIXME: avoide staff lines, leadger lines or others.


        var ctx = this.context;
        ctx.save();
        ctx.setLineWidth(1 * offsetScale); // FIXME: use more appropriate value.

        ctx.beginPath();
        ctx.moveTo(slashBBox.x1, slashBBox.y1);
        ctx.lineTo(slashBBox.x2, slashBBox.y2);
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
      }
    }
  }, {
    key: "calcBeamedNotesSlashBBox",
    value: function calcBeamedNotesSlashBBox(slashStemOffset, slashBeamOffset, protrusions) {
      var beam = this.beam;
      var beam_slope = beam.slope;
      var isBeamEndNote = beam.notes[beam.notes.length - 1] === this;
      var scaleX = isBeamEndNote ? -1 : 1;
      var beam_angle = Math.atan(beam_slope * scaleX); // slash line intersecting point on beam.

      var iPointOnBeam = {
        dx: Math.cos(beam_angle) * slashBeamOffset,
        dy: Math.sin(beam_angle) * slashBeamOffset
      };
      slashStemOffset *= this.getStemDirection();
      var slash_angle = Math.atan((iPointOnBeam.dy - slashStemOffset) / iPointOnBeam.dx);
      var protrusion_stem_dx = Math.cos(slash_angle) * protrusions.stem * scaleX;
      var protrusion_stem_dy = Math.sin(slash_angle) * protrusions.stem;
      var protrusion_beam_dx = Math.cos(slash_angle) * protrusions.beam * scaleX;
      var protrusion_beam_dy = Math.sin(slash_angle) * protrusions.beam;
      var stemX = this.getStemX();
      var stem0X = beam.notes[0].getStemX();
      var stemY = this.beam.getBeamYToDraw() + (stemX - stem0X) * beam_slope;
      var ret = {
        x1: stemX - protrusion_stem_dx,
        y1: stemY + slashStemOffset - protrusion_stem_dy,
        x2: stemX + iPointOnBeam.dx * scaleX + protrusion_beam_dx,
        y2: stemY + iPointOnBeam.dy + protrusion_beam_dy
      };
      return ret;
    }
  }]);

  return GraceNote;
}(StaveNote);